import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';

@Component({
  selector: 'app-iconify-icon',
  standalone: true,
  imports: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './iconify-icon.component.html',
  styleUrl: './iconify-icon.component.scss',
})
export class IconifyIconComponent {
  @Input({ required: true }) icon!: string;
  @Input() class: string = '';
}
